import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import * as config from '../config';
import './login.css';

function Report() {
  const [supplierBills, setSupplierBills] = useState([]);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const loginId = localStorage.getItem('login_id');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${config.DevelopmentUri}/api/Dashboard/GatherSupplierBillsDetails/${loginId}`);
        setSupplierBills(response.data);
      }
      catch (error) {
        setError(error.response ? error.response.data : error.message);
      }
    };
    if (loginId) {
      fetchData();
    } else {
      navigate('/login');
    }
  }, [loginId, navigate]);


  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className='MainReport'>
      <div className='table-container'>
        <h1 className='heading'>Bill Status</h1>
        <table id="report" style={{ border: '1px solid #dddddd' }}>
          <thead>
            <tr>
              <th>SL</th>
              <th style={{ width: '40%' }}>Bill Subject</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Submitted</th>
              <th>Approved</th>
              <th>Send To <br /> AG Office</th>
            </tr>
          </thead>
          <tbody>
            {supplierBills.map((bill, index) => (
              <tr key={bill.vendor_id}>
                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                <td>{bill.letter_subject_letter}</td>
                <td>{bill.letter_date_letter}</td>
                <td style={{ textAlign: 'right' }}>{bill.administrative_approval_cost}</td>
                <td style={{ textAlign: 'center' }}>{bill.submited}</td>
                <td style={{ textAlign: 'center' }}>{bill.approved}</td>
                <td style={{ textAlign: 'center' }}>{bill.ag_office}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Report;
